<template>
  <div id="login">
    <div class="header">
      <div href="#" class="logo">
        <img class="logo-img" src="@/assets/img/login/login_logo.png" />
      </div>
    </div>
    <div class="content">
      <div class="login-banner-wrap">
        <div style="text-align: center" v-if="flgPro">
          <el-select
            v-model="loginName"
            placeholder="开发使用-请选择"
            @change="changeUsername"
          >
            <el-option
              v-for="item in loginInfo"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="login-form-content">
        <div class="login-form clearfix">
          <ul class="form-header">
            <li
              :class="passwordLoginCss"
              type="password"
              @click="changeLoginType('password')"
            >
              账号密码登录
            </li>
            <li
              :class="mobileLoginCss"
              type="mobile"
              @click="changeLoginType('mobile')"
            >
              手机号码登录
            </li>
          </ul>
          <!--账号密码登录-->
          <div
            class="form-content account-form"
            v-show="showPasswordLogin"
            data-type="password"
          >
            <div class="form-wrap">
              <el-form
                :model="loginFormPassword"
                :rules="rulesPassword"
                ref="loginFormPwd"
              >
                <el-form-item label="" prop="username" class="input-wrap">
                  <div class="loginInput">
                    <el-input
                      v-model="loginFormPassword.username"
                      :maxlength="20"
                      placeholder="用户账号"
                      prefix-icon="el-icon-user"
                    >
                    </el-input>
                  </div>
                </el-form-item>
                <el-form-item label="" prop="password" class="input-wrap">
                  <div class="loginInput">
                    <el-input
                      type="password"
                      v-model="loginFormPassword.password"
                      :maxlength="20"
                      placeholder="登录密码"
                      prefix-icon="el-icon-lock"
                      show-password
                    ></el-input>
                  </div>
                </el-form-item>
                <el-form-item label="" prop="captcha" class="input-wrap">
                  <el-col :span="10">
                    <div class="loginInput">
                      <el-input
                        v-model="loginFormPassword.captcha"
                        :maxlength="4"
                        placeholder="验证码"
                        prefix-icon="el-icon-key"
                        @keyup.enter.native="login('loginFormPwd')"
                      >
                      </el-input>
                    </div>
                  </el-col>
                  <el-col :span="1">&nbsp;</el-col>
                  <el-col :span="10">
                    <div
                      @click="refreshCode"
                      style="cursor: pointer; width: 100%; height: 36px"
                    >
                      <img
                        :src="captchaCode"
                        style="cursor: pointer; height: 32px"
                      />
                    </div>
                  </el-col>
                </el-form-item>
              </el-form>
              <div class="account-action">
                <div class="login-type">
                  <a
                    class="change-login-type"
                    type="mobile"
                    data-type="password"
                    style="cursor: default"
                    >&nbsp;</a
                  >
                  <div class="forget-wrap">
                    <a
                      href="javascript:;"
                      class="forget-password"
                      @click="toFindPassword"
                      ><i class="icon-forget"></i>忘记密码</a
                    >
                  </div>
                </div>
              </div>
              <span
                class="login-btn password-login"
                @click="login('loginFormPwd')"
                >{{ loginBtnTxt }}</span
              >
              <a href="#" class="reg-btn password-login" @click="toRegister()"
                >注册</a
              >
              <div class="account-remark">
                <i class="icon-remind"></i
                >请使用Chrome、Edge、FireFox、360(极速模式)浏览器操作
              </div>
            </div>
          </div>
          <!--手机登录-->
          <div
            class="form-content account-form"
            style="padding-top: 20px"
            v-show="showMobileLogin"
            data-type="mobile"
          >
            <div class="form-wrap">
              <el-form
                :model="loginFormMobile"
                :rules="rulesMobile"
                ref="loginFormMobile"
              >
                <el-form-item label="" prop="username" class="input-wrap">
                  <div class="loginInput">
                    <el-input
                      v-model="loginFormMobile.username"
                      :maxlength="11"
                      show-word-limit
                      placeholder="手机号码"
                      autocomplete="off"
                    >
                    </el-input>
                  </div>
                </el-form-item>
                <el-form-item label="" prop="password" class="input-wrap">
                  <div class="loginInput">
                    <el-input
                      style="width: 280px"
                      placeholder="短信验证码"
                      v-model="loginFormMobile.password"
                      maxlength="6"
                      show-word-limit
                      autocomplete="off"
                    >
                      <el-button
                        slot="append"
                        class="btnGetCode"
                        @click="getCode"
                        :disabled="disableGetSMSCode"
                        >{{ valBtn }}</el-button
                      ></el-input
                    >
                  </div>
                </el-form-item>
              </el-form>
              <div style="padding: 10px 0">&nbsp;</div>
              <span
                class="login-btn password-login"
                @click="login('loginFormMobile')"
                >{{ loginBtnTxt }}</span
              >
              <a href="#" class="reg-btn password-login" @click="toRegister()"
                >注册</a
              >
              <div class="account-remark">
                <i class="icon-remind"></i
                >请使用Chrome、Edge、FireFox、360(极速模式)浏览器操作
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-header">
        <a href="https://www.smesc.cn/about/index.html" target="_blank"
          >关于我们</a
        >|
        <a href="https://www.smesc.cn/about/contact.html" target="_blank"
          >联系我们</a
        >|
        <a href="https://www.smesc.cn/about/copyright.html" target="_blank"
          >隐私政策</a
        >
      </div>
      <div class="copyright">
        &copy;&nbsp;2004-2023&nbsp;四川中小企业信息服务有限责任公司&nbsp;&nbsp;<a
          href="https://beian.miit.gov.cn/#/Integrated/index"
          target="_blank"
          >蜀ICP备11006773号-11</a
        >&nbsp;&nbsp;<a
          href="https://beian.mps.gov.cn/#/query/webSearch"
          target="_blank"
          >川公网安备51010602001543号</a
        >
      </div>
      <div class="register-info" v-html="pVer"></div>
    </div>
  </div>
</template>

<script>
import commonParam from "@/param/commonParam";
import regx from "@/param/regx";
import { getData, setData, setDataSS } from "@/store/storeUtil";
import { successMsg, errorMsg } from "@/utils/messageUtil";
import ax from "axios";
import {
  REFRESH_TOKEN,
  TOKEN,
  TOKEN_TIME,
  USER_NAME,
  USER_ID,
} from "@/store/method_param";
import { get, post, postBody } from "@/utils/httpUtil";
import { getToken } from "@/utils/tokenUtil";

export default {
  name: "LoginIndex",
  data() {
    return {
      rulesPassword: {
        username: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        captcha: [
          { required: true, message: "请输入右侧验证码", trigger: "blur" },
        ],
      },
      rulesMobile: {
        username: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入短信验证码", trigger: "blur" },
        ],
      },
      flgPro:
        commonParam.serverUrl.search("localhost") !== -1 ||
        commonParam.serverUrl.search("192.168.1") !== -1 ||
        commonParam.serverUrl.search("127.0.0.1") !== -1
          ? true
          : false,
      showPasswordLogin: true,
      passwordLoginCss: "login-tab account-tab active",
      mobileLoginCss: "login-tab account-tab",
      showMobileLogin: false,
      disableGetSMSCode: false,
      pVer: commonParam.footerText,
      loginUrl: "/uaa/authLogin",
      getCaptchaUrl: "/auth/authUser/code/image",
      sendSMSUrl: "/pub/sms/sendLoginSMSVerCode",
      loginBtnTxt: "登录",
      valBtn: "获取短信验证码",
      userToken: "",
      loginFormPassword: {},
      loginFormMobile: {},
      homePagePath: "/optionModule",
      portalTokenUrl: commonParam.portalSaveTokenUrl,
      rUrl: "",
      timer: null,
      countTimer: "",
      loginName: "企业",
      loginInfo: [
        {
          name: "企业",
          info: {
            username: "scmofit",
            password: "0",
          },
        },
        {
          name: "机构",
          info: {
            username: "69919866-2",
            password: "0",
          },
        },
        {
          name: "平台",
          info: {
            username: "SPLT510000",
            password: "0",
          },
        },
        {
          name: "主管部门",
          info: {
            username: "510000",
            password: "0",
          },
        },
        {
          name: "管理员",
          info: {
            username: "admin",
            password: "0",
          },
        },
      ],
      captchaCode: "",
      captchaId: "",
    };
  },
  methods: {
    init() {
      let then = this;
      get(this.getCaptchaUrl, {}).then((resp) => {
        if (resp != null && resp != "" && resp != undefined) {
          then.captchaId = resp.substring(0, 32);
          then.captchaCode = "data:image/jpg;base64," + resp.substring(32);
        }
      });

      this.checkCurrentLogin();
      if (this.flgPro) {
        this.loginFormPassword = {
          username: "scmofit",
          password: "0",
        };
      }

      // 验证距离上次获取短信验证码后有无剩余CD
      let sms_code_sysj = localStorage.getItem("sms_code_djs_dl");
      if (sms_code_sysj && sms_code_sysj > 0) {
        if (!this.timer) {
          this.countTimer = sms_code_sysj;
          this.disableGetSMSCode = true;
          this.timer = setInterval(() => {
            if (this.countTimer > 0 && this.countTimer <= sms_code_sysj) {
              this.countTimer--;
              localStorage.setItem("sms_code_djs_dl", this.countTimer);
              this.valBtn = this.countTimer + "s后可重新获取";
            } else {
              this.disableGetSMSCode = false;
              clearInterval(this.timer);
              this.timer = null;
              localStorage.removeItem("sms_code_djs_dl");
              this.valBtn = "获取短信验证码";
            }
          }, 1000);
        }
      }
    },
    //登录按钮
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginAxios();
        } else {
          this.refreshCode();
          return false;
        }
      });
    },
    changeLoginType(val) {
      if ("password" == val) {
        this.showPasswordLogin = true;
        this.showMobileLogin = false;
        this.passwordLoginCss = "login-tab account-tab active";
        this.mobileLoginCss = "login-tab account-tab";
      } else {
        this.showPasswordLogin = false;
        this.showMobileLogin = true;
        this.passwordLoginCss = "login-tab account-tab";
        this.mobileLoginCss = "login-tab account-tab active";
      }
    },
    //登录
    async loginAxios() {
      const loading = this.$loading({
        lock: true,
        text: "登录中，请稍等...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.loginBtnTxt = "登录中...";
      let dataInfo = {};
      if (this.showPasswordLogin) {
        dataInfo = Object.assign({}, this.loginFormPassword);
      } else {
        dataInfo = Object.assign({}, this.loginFormMobile);
        this.$set(dataInfo, "tp", "sms");
      }
      this.$set(dataInfo, "grant_type", "password");
      const encodeUserName = await this.$getRsaCode(dataInfo.username);
      const encodePwd = await this.$getRsaCode(dataInfo.password);
      this.$set(dataInfo, "password", encodePwd);
      this.$set(dataInfo, "username", encodeUserName);
      this.$set(dataInfo, "captchaId", this.captchaId);
      this.$set(dataInfo, "system", "公共服务平台");
      let then = this;
      let lgSuccess = false;
      await postBody(this.loginUrl, dataInfo).then((resp) => {
        if (resp.result) {
          this.$message({
            showClose: true,
            message: "登录成功，欢迎回来",
            type: "success",
            duration: 2 * 1000,
          });
          then.userToken = resp.data.access_token; //获取登录用户 token
          setData(TOKEN, then.userToken);
          setData(REFRESH_TOKEN, resp.data.refresh_token);
          setData(TOKEN_TIME, new Date().getTime());
          setData(USER_NAME, resp.data.nickName);
          setDataSS(USER_ID, resp.data.id);
          loading.close();
          lgSuccess = true;
        } else {
          this.$message.warning({
            showClose: true,
            message: "登录失败：" + resp.message,
          });
          this.refreshCode();
          this.loginBtnTxt = "登录";
          loading.close();
        }
      });

      if (lgSuccess) {
        if (then.rUrl == "") {
          setTimeout(() => {
            then.$router.push(then.homePagePath);
          }, 1000);
        } else {
          let d = new Object();
          const tk = getData(TOKEN);
          const rtk = getData(REFRESH_TOKEN);
          const un = getData(USER_NAME);
          const tt = getData(TOKEN_TIME);
          const ep = commonParam.tokenOverdueTime;
          this.$set(d, "token", tk);
          this.$set(d, "refresh_token", rtk);
          this.$set(d, "user_name", un);
          this.$set(d, "token_time", tt);
          this.$set(d, "expires", ep);
          let r = await ax({
            url: then.portalTokenUrl,
            method: "post",
            data: d,
          });
          if (r.data.result) {
            window.location.href = then.rUrl;
          }
        }
      }
    },
    // 前往注册页面
    toRegister() {
      this.$router.push("/register");
    },
    toFindPassword() {
      this.$router.push("/findPassword");
    },
    changeUsername() {
      let loginInfo = this.loginInfo.filter((item) => {
        if (this.loginName == item.name) {
          return item;
        }
      });
      if (loginInfo && loginInfo[0]) {
        this.loginFormPassword = loginInfo[0].info;
      }
    },
    // 点击验证码
    refreshCode() {
      this.captchaCode = "";
      this.captchaId = "";
      let then = this;
      get(this.getCaptchaUrl, {}).then((resp) => {
        if (resp != null && resp != "" && resp != undefined) {
          then.captchaId = resp.substring(0, 32);
          then.captchaCode = "data:image/jpg;base64," + resp.substring(32);
        }
      });
    },
    // 验证当前用户是否已经登录
    checkCurrentLogin() {
      let token = getToken();
      if (token) {
        const loading = this.$loading({
          lock: true,
          text: "已登录，页面正在跳转中!",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.5)",
        });
        setTimeout(() => {
          loading.close();
          this.$router.push(this.homePagePath);
        }, 1000);
      }
    },
    // 发送短信验证码
    getCode() {
      const userMobile = this.loginFormMobile.username;
      if (userMobile == null || userMobile == "" || userMobile == undefined) {
        this.$refs.loginFormMobile.validateField("username");
      } else {
        if (regx.mobile.test(userMobile)) {
          post(this.sendSMSUrl, { mobile: userMobile }).then((resp) => {
            if (resp.result) {
              successMsg(this, "验证码发送成功！");
            } else {
              errorMsg(this, resp.message);
            }
          });
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.countTimer = TIME_COUNT;
            this.disableGetSMSCode = true;
            this.timer = setInterval(() => {
              if (this.countTimer > 0 && this.countTimer <= TIME_COUNT) {
                this.countTimer--;
                localStorage.setItem("sms_code_djs_dl", this.countTimer);
                this.valBtn = this.countTimer + "s后可重新获取";
              } else {
                this.disableGetSMSCode = false;
                clearInterval(this.timer);
                this.timer = null;
                this.valBtn = "获取短信验证码";
                localStorage.removeItem("sms_code_djs_dl");
              }
            }, 1000);
          }
        } else {
          this.$refs.loginFormMobile.validateField("username");
        }
      }
    },
  },
  mounted() {
    this.$watermark.set("");
    const geturl = window.location.href;
    let getqyinfo = geturl.split("?")[1];
    let getqys = new URLSearchParams("?" + getqyinfo);
    let getqycode = getqys.get("r");
    if (getqycode != null && getqycode != undefined && getqycode != "") {
      this.rUrl = getqycode;
    }
  },
  created() {
    this.init();
  },
};
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

ul li {
  list-style: none;
}

a {
  background-color: transparent;
  text-decoration: none;
  color: #006eff;
  cursor: pointer;
}

body {
  color: #32465a;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif !important;
  overflow: hidden;
  background: #ffffff;
}
.clearfix {
  clear: both;
}
#login {
  background-color: #fff;
  font-size: 14px;
}

#login .header {
  height: 80px;
  width: 1280px;
  margin: auto;
  position: relative;
  background: #ffffff;
}

#login .header .logo {
  display: inline-block;
  height: 100%;
  margin-right: 20px;
}

#login .header .logo-img {
  height: 70px;
  margin-top: 5px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#login .header .title {
  display: inline-block;
  vertical-align: top;
  height: 54px;
  margin-top: 23px;
  line-height: 54px;
  font-size: 24px;
  color: #96aec5;
  padding-left: 20px;
  position: relative;
  border-left: 1px solid #c7cddc;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

#login .content {
  position: relative;
  height: 420px;
}

#login .login-banner-wrap {
  width: 100%;
  height: 420px;
  background: #04050d url(@/assets/img/login/login-bg.png) no-repeat center;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
}

#login .login-form-content {
  width: 1200px;
  margin: 0 auto;
}

.login-form {
  height: 360px;
  width: 360px;
  border-radius: 10px;
  position: relative;
  float: right;
  top: 30px;
  right: 80px;
  background: #fff;
}
.login-form .form-header {
  width: 100%;
  height: 54px;
  border-bottom: 1px solid #d8d8d8;
  padding: 0 30px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.login-form .login-tab {
  float: left;
  width: 120px;
  text-align: center;
  line-height: 54px;
  font-size: 18px;
  margin: 0 15px;
  color: #333333;
  cursor: pointer;
}

.login-form .login-tab:hover {
  color: #197aff;
}

.login-form .login-tab.active {
  position: relative;
  color: #197aff;
}

.login-form .login-tab.active:after {
  content: "";
  position: absolute;
  width: 120px;
  height: 3px;
  background-color: #197aff;
  left: 0;
  bottom: 0;
}
.form-content .error-text {
  width: 320px;
  margin: 3px auto;
  min-height: 26px;
  line-height: 26px;
  padding: 0 5px;
  padding-top: 2px;
  background-color: #ffefee;
  color: #ff625c;
  /*visibility: hidden;*/
  font-size: 12px;
  border-radius: 4px;
}
.form-content .error-text .box {
  display: flex;
  width: 316px;
  height: 20px;
  border: 0px solid;
  align-items: center; /*副轴居中*/
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.form-content .error-text .text {
  padding-left: 5px;
}

label {
  display: inline-block;
  vertical-align: baseline;
  *vertical-align: auto;
  *zoom: 1;
  *display: inline;
  margin-right: 2px;
}
.form-content .input-wrap {
  position: relative;
  width: 100%;
  height: 36px;
  margin-top: 10px;
  margin-bottom: 16px;
}

.form-wrap {
  width: 320px;
  margin: auto;
}
.account-action {
  width: 100%;
  padding: 0px 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.login-type {
  width: 320px;
  margin: 10px auto 0;
}
.login-type .change-login-type {
  color: #197aff;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.login-type .change-login-type:hover {
  text-decoration: none;
}
.form-content[data-type="password"] .forget-wrap {
  float: right;
}

.form-content[data-type="password"] .forget-wrap {
  position: relative;
  float: right;
  cursor: pointer;
}

.form-content[data-type="password"] .forget-account,
.form-content[data-type="password"] .forget-password {
  color: #32465a;
}

.form-content[data-type="password"] .forget-account:hover,
.form-content[data-type="password"] .forget-password:hover {
  color: #197aff;
  text-decoration: none;
}

.account-remark {
  width: 100%;
  height: 45px;
  position: absolute;
  bottom: 0;
  border-radius: 0 0 10px 10px;
  line-height: 44px;
  font-size: 12px;
  text-align: left;
  background-color: #fbfcfd;
  border-top: 1px solid #d8d8d8;
  padding: 0 18px;
  left: 0px;
  user-select: none;
}

.login-btn {
  display: inline-block;
  width: 150px;
  height: 40px;
  margin: 10px auto 0;
  margin-top: 15px;
  line-height: 40px;
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  background-color: #197aff;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 5px 10px 0 rgba(51, 119, 255, 0.44);
  user-select: none;
}
.login-btn:hover {
  background-color: #200aaa;
}
.reg-btn {
  display: inline-block;
  width: 150px;
  height: 40px;
  margin: 10px auto 0;
  margin-left: 20px;
  margin-top: 15px;
  line-height: 40px;
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  background-color: #047420;
  color: #fff;
  cursor: pointer;
  box-shadow: 0 5px 10px 0 rgba(51, 119, 255, 0.44);
  user-select: none;
}
.reg-btn:hover {
  background-color: #014211;
}
.footer {
  font-size: 14px;
}
.footer .footer-header {
  margin: auto;
  width: 420px;
  overflow: hidden;
  margin-top: 10px;
  user-select: none;
  text-align: center;
}

.footer .footer-header a {
  margin: 0 15px;
  position: relative;
  text-align: center;
  height: 15px;
  line-height: 15px;
}

.footer .footer-header a {
  color: #32465a;
}

.footer .footer-header a:hover {
  color: #197aff;
}

.footer .footer-header .last:after {
  display: none;
}

.footer .copyright {
  text-align: center;
  margin-top: 10px;
  color: #32465a;
  user-select: none;
}

.footer .register-info {
  height: 24px;
  text-align: center;
  margin-top: 6px;
  margin-bottom: 24px;
  color: #32465a;
  user-select: none;
}
.btnGetCode {
  padding: 0 5px;
}
.btnGetCode:hover {
  color: #000000;
  background: none;
}
</style>
